<template>
  <div>
    <page-header title="Podcast" class="page-banner"></page-header>
    <div class="container">
      <content-loader v-if="$apollo.loading" title="Jobs" />
      <div v-else>
        <div
          class="row mb-3 align-items-sm-center d-flex justify-content-between"
        >
          <div class="col-sm-6">
            <h2 class="cs-textstyle-page-subtitle">Latest Episode</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <app-featured-episode
              :podcast="podcasts[0]"
              @click="onOpenPodcastDetails(podcasts[0])"
            />
          </div>
        </div>
        <div class="row mt-5 podcast-items">
          <div class="cs-textstyle-section-heading col-sm-12 mt-3">
            Episodes
          </div>
          <div
            v-for="podcast in podcasts.slice(1, podcasts.length)"
            :key="podcast.id"
            class="col-sm-12"
          >
            <app-podcast-item
              :podcast="podcast"
              @click="onOpenPodcastDetails(podcast)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/global/PageHeader';
import ContentLoader from '@/components/global/ContentLoader';
import ListPodcastEpisodes from '@/newgql/ListPodcastEpisodes.gql';
import AppPodcastItem from '@/components/podcast/PodcastItem';
import AppFeaturedEpisode from '@/components/podcast/FeaturedEpisode';
export default {
  components: {
    PageHeader,
    ContentLoader,
    AppPodcastItem,
    AppFeaturedEpisode
  },

  apollo: {
    podcasts: ListPodcastEpisodes
  },
  methods: {
    onOpenPodcastDetails(podcast) {
      this.$router.push({ name: 'PodcastDetail', params: { id: podcast.id } });
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  text-align: left;
  margin-bottom: 60px;
}

.button-class {
  margin-top: 20px;
}

.podcast-items {
  display: flex;
  gap: 15px;
  flex-direction: column;
}
</style>
